import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula a quantidade média mensal dividindo a quantidade pelos 12 meses do ano */
export function calcularQuantidadeMediaMensal(quantidade: number): number {
    quantidade = quantidade && !isNaN(quantidade) ? Number(quantidade) : 0;

    const quantidadeMediaMensal = quantidade / 12;
    return toFixed(quantidadeMediaMensal, 6)
}

/** Calcula o peso médio mensal dividindo o peso pelos 12 meses do ano */
export function calcularPesoMedioMensal(peso: number): number {
    peso = peso && !isNaN(peso) ? Number(peso) : 0;

    const pesoMedioMensal = peso / 12;
    return toFixed(pesoMedioMensal, 6)
}

/** Calcula o valor médio mensal divindindo o valor pelos 12 meses do ano */
export function calcularValorMedioMensal(valor: number): number {
    valor = valor && !isNaN(valor) ? Number(valor) : 0;

    const valorMedioMensal = valor / 12;
    return toFixed(valorMedioMensal, 4)
}
